<template>
  <div id="perennial">
    <big-top title="Garden Map"></big-top>
    <div class="perennialmap">
      <fullmap exhibit-group="perennial" :mapopts="{start_zoom: 18, center: [-73.88118544360624, 40.86376093100409]}"></fullmap>
    </div>
    <mapControls></mapControls>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import Fullmap from './Fullmap.vue'
import mapControls from './MapControls.vue'
export default {
  name: 'perennialmap',
  components: { Fullmap, mapControls }
}
</script>
<style lang="scss" scoped>
#perennial {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.exhibit-distance {
  background-color: white;
  font-size: 1em;
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px 0;
}

.begin {
  width: 50%;
  left: 25%;
  display: inline-block;
  position: absolute;;
  top: -50px;
}

.perennialmap {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #a4b56e;
}
</style>
